import React from 'react';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

export type PrimaryTitleProps = {
    children?: React.ReactNode;
};
export function PrimaryTitle({ children }: PrimaryTitleProps) {
    return (
        <>
            <Typography variant="h2" component="h2" sx={{ marginBottom: 0, textAlign: 'center', fontSize: '2.375rem', fontWeight: 'bold' }}>
                {children}
            </Typography>
            <Divider sx={{ borderColor: '#0E2038', width: '40px', borderBottomWidth: '2px', mx: 'auto', mt: 3, mb: 4 }} />
        </>
    );
}
